module.exports = __webpack_public_path__ + "img/cancel.43323e84.svg";